import * as Yup from 'yup';

export default function ReimbursementRequestSchema() {
  return Yup.object({
    date: Yup.date().nullable().required('Date is required'),

    description: Yup.string()
      .min(1, 'Description is required')
      .max(2000, 'Description must be less than 2000 characters')
      .required('Description is required'),

    amount: Yup.number()
      .typeError('Amount must be a number')
      .positive('Amount must be greater than zero')
      .max(9999999.99, 'Amount is too large')
      .test('decimal-places', 'Amount can have at most 2 decimal places', (value) => {
        if (value === undefined || value === null) return true;
        return /^\d+(\.\d{1,2})?$/.test(String(value));
      })
      .required('Amount is required'),

    attachmentKey: Yup.string().nullable().notRequired(),
    attachmentUrl: Yup.string().nullable().notRequired(),

    reviewers: Yup.array()
      .of(Yup.number().integer().positive())
      .min(1, 'At least one reviewer must be selected')
      .required('At least one reviewer is required'),
  });
}
